import { z } from 'zod';

/**
 * Catalogo MCP letto dalla SPA tenant (`GET /mcp/servers`,
 * `GET /mcp/servers/:id/tools`). Source of truth:
 * `packages/backend/src/routes/api-v2/mcp.routes.ts`.
 * Il server "internal" risponde con i tool del registry (campi `tags`,
 * `priority`, `short_description`, `registry_function_key`); i server
 * esterni con le righe `mcp_server_tools` + permessi tenant.
 */
export const mcpServerListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  enabled: z.boolean(),
  description: z.string().nullable().optional(),
  transport: z.string().optional(),
  endpoint: z.string().nullable().optional(),
  auth_type: z.string().nullable().optional(),
  health_status: z.string().nullable().optional(),
  last_health_check: z.string().nullable().optional(),
  tool_count: z.union([z.number(), z.string()]).optional(),
  is_global: z.boolean().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});
export type McpServerListItem = z.infer<typeof mcpServerListItemSchema>;

export const mcpServerToolListItemSchema = z.object({
  id: z.string(),
  tool_name: z.string(),
  description: z.string(),
  /** Valorizzato dal consumer quando aggrega i tool di più server. */
  mcp_server_id: z.string().optional(),
  server_name: z.string().optional(),
  is_internal: z.boolean().optional(),
  category: z.string().optional(),
  registry_function_key: z.string().optional(),
  tags: z.array(z.string()).optional(),
  priority: z.number().optional(),
  short_description: z.string().nullable().optional(),
  enabled: z.boolean().optional(),
  allowed: z.boolean().optional(),
  require_confirmation: z.boolean().optional(),
  max_calls_per_session: z.number().nullable().optional(),
  input_schema: z.unknown().optional(),
  operation_semantics: z.unknown().optional(),
});
export type McpServerToolListItem = z.infer<typeof mcpServerToolListItemSchema>;
